import { Base } from '@studiometa/js-toolkit';

/**
 * HeaderMobile class.
 */
export default class TopBar extends Base {
  static config = {
    name: 'TopBar',
    refs: ['topBarMessage[]'],
  };

  /**
   * Mounted
   */
  mounted() {
    const topBarMessageRef = this.$refs.topBarMessage ?? [];

    const messages = [...topBarMessageRef];
    let currentMessagePosition = 0;

    if (messages.length > 0) {
      window.setInterval(() => {
        messages[currentMessagePosition].classList.remove('translate-y-full');
        currentMessagePosition += 1;

        if (currentMessagePosition >= messages.length) {
          currentMessagePosition = 0;
        }

        messages[currentMessagePosition].classList.add('translate-y-full');
      }, 5000);
    }
  }
}
